import React from 'react'
import NavLink from '../Routes/NavLink'

import BuildingCard from '../Building/BuildingCard.jsx'

import { activeSensorsManager } from '../../core/controllers/ActiveSensorsManager'
import {buildings} from '../../core/controllers/Buildings'

export default class BuildingsList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null
        };

        this.lastSortID = "all";
    }

    componentDidMount() {
        buildings.getBuildings(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.lastSortID != nextProps.sortID) {
            this.lastSortID = nextProps.sortID;
            buildings.getBuildings(this)
        }
    }

    componentWillUnmount() {
        activeSensorsManager.clearWindowTimeouts();
    }

    render(){
        const buildingData = this.state.data;
        return (
            <div>
                {buildingData != null && buildingData.length > 0 ? ( 
                    buildingData.map(function(building, index){
                        const buildingDetails = building.data;
                        const buildingData = building.belongsTo;
                        const buildingMetaData = building.meta_data;
                        return (
                            <BuildingCard key={buildingData.building_id} buildingDetails={buildingDetails} buildingData={buildingData} buildingMetaData={buildingMetaData}/>
                        )
                    })
                ) : (
                        <div class="col-md-4">
                            <p>You have no properties, try adding some.</p>
                        </div>
                    )
                }
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Buildings/BuildingsList.jsx